package nl.volleyplanner.api.planner

import kotlinx.serialization.Serializable


@Serializable
data class ProblemStatistics(
    val problem: PlanningProblem,
    val personStatistics: List<PersonTaskStatistics>,
    val taskStatistics: List<TaskStatistics>,
    val maxPersonMatchCount: Int
) {
    val personStatisticsById = personStatistics.associateBy { it.person.id }
    val taskStatisticsById = taskStatistics.associateBy { it.task.id }
}
